/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_Class_Table_HintInputs */

const en_reading_class_table_hint = /** @type {(inputs: Reading_Class_Table_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text inside tables`)
};

const es_reading_class_table_hint = /** @type {(inputs: Reading_Class_Table_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto dentro de las tablas`)
};

/**
* | output |
* | --- |
* | "Text inside tables" |
*
* @param {Reading_Class_Table_HintInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reading_class_table_hint = /** @type {((inputs?: Reading_Class_Table_HintInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_Class_Table_HintInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_reading_class_table_hint(inputs)
	return en_reading_class_table_hint(inputs)
});